import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/OutputDataDetails.module.css";
import { formatDateToLocalDate } from "../../utils/utils";
import useCurrencySymbol from "../../hooks/useCurrencySymbol";
import ButtonExpand from "../ui/button_expand/ButtonExpand";
import { useTranslation } from "react-i18next";
import useNumberFormat from "../../hooks/useNumberFormat";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../ui/button/Button";
import Spinner from "../ui/spinner/Spinner";
import POSDataContext from "../../context/POSDataContext";
import DataContext from "../../context/DataContext";
import { axiosSW } from "../../api/axiosDefaults";

const PAYMENT = "payment";
const REFUND = "refund";
const EXCLUDED = ["base amount", PAYMENT, REFUND];

const OutputDataDetails = ({
    label,
    data,
    icon: Icon,
    align,
    notAvialableMessage,
    placeHolder,
    reset,
    ticketId,
}) => {
    const [showDetails, setShowDetails] = useState(false);
    const [clickedButton, setClickedButton] = useState(null);

    const { t } = useTranslation();
    const formatNum = useNumberFormat();

    const {
        isProcessingChargesPos,
        filterExpression,
        fetchTickets,
        setIsProcessingChargesPos,
        handleErrorPos,
    } = useContext(POSDataContext);
    const { connection, homePath } = useContext(DataContext);

    const location = useLocation();
    const navigate = useNavigate();
    const currency = useCurrencySymbol(location.pathname.includes("/pos"));

    const handleUpdateCharge = async (event, isCancel) => {
        event.preventDefault();
        if (isProcessingChargesPos) return;

        const APIAdress =
            isCancel === true
                ? "late-fee-management/pos/LateFeeCancellation"
                : "late-fee-management/pos/LateFeeReset";
        setIsProcessingChargesPos(true);
        setClickedButton(parseInt(event.target.dataset.ex));
        const payload = {
            uniqueIdentifier: connection?.uniqueIdentifier,
            chargeId: parseInt(event.target.dataset.ex),
            ticketId: parseInt(ticketId),
        };

        try {
            const { data } = await axiosSW.post(APIAdress, payload);
            if (data?.statusOk) {
                if (filterExpression) {
                    fetchTickets(filterExpression, 2);
                }
            }
        } catch (error) {
            console.log(error);
            console.log("error status: ", error?.request?.status);
            setIsProcessingChargesPos(false);
            if (error?.request?.status === 400) {
                navigate(homePath);
            } else handleErrorPos(error);
        }
    };
    const [isUpdateTypeCharge, setIsUpdateTypeCharge] = useState(false);
    const [lastChargesAvailable, setLastChargesAvailable] = useState(false);

    useEffect(() => {
        if (!data) return;

        setLastChargesAvailable(data.some((item) => isCancelable(item?.txt)));
    }, [data]);

    useEffect(() => {
        if (isProcessingChargesPos) {
            setIsUpdateTypeCharge(true);
        }
    }, [isProcessingChargesPos]);

    useEffect(() => {
        if (isUpdateTypeCharge) {
            setIsUpdateTypeCharge(false);
        } else {
            setShowDetails(false);
            setIsUpdateTypeCharge(false);
        }
    }, [reset]);

    const isCancelable = (chrageName) => {
        // let isCancelableCharge = false

        const noMatch = EXCLUDED.some(
            (word) =>
                typeof chrageName === "string" &&
                chrageName.toLowerCase() === t(word),
        );
        return !noMatch;

        // return (
        //     typeof chrageName === "string" &&
        //     chrageName.toLowerCase() !== t(BASE_AMOUNT) &&
        //     chrageName.toLowerCase() !== t(REFUND) &&
        //     chrageName.toLowerCase() !== t(PAYMENT)
        // );
    };

    // ------------------------------------------------------------------------------- Charge row
    const ChargeRow = ({ item }) => {
        return (
            <div
                key={item?.id}
                className={`${styles.output_details} ${
                    item?.isCancelled ? styles.charge_removed : ""
                }  ${
                    lastChargesAvailable ? styles.charge_padding : ""
                } flex-container`}
            >
                <span
                    className={`${styles.output_details_label} ${
                        styles.output_details_type
                    } ${
                        location.pathname.includes("/pos")
                            ? styles.extend_pos
                            : ""
                    } `}
                >
                    {t(item?.txt)}
                </span>
                <span
                    className={`${styles.output_details_value} ${styles.output_details_date} ${styles.condition_hide_2nd}`}
                >
                    {formatDateToLocalDate(item?.dateAndTime, true)}
                </span>
                <span
                    className={`${styles.output_details_value} ${styles.output_details_currency} ${styles.condition_hide}`}
                >
                    {item?.txt.toLowerCase() === t(PAYMENT) ||
                    item?.txt.toLowerCase() === t(REFUND)
                        ? t("included")
                        : `${currency}${formatNum(item?.taxAmount)}`}
                </span>
                <span
                    className={`${styles.output_details_value} ${styles.output_details_currency}`}
                >
                    {` ${
                        item?.txt.toLowerCase() === t(PAYMENT) ? "-" : ""
                    } ${currency}${formatNum(item?.netAmount)}`}
                </span>

                {location.pathname.includes("/pos") && lastChargesAvailable ? (
                    <span className={` ${styles.output_charge_button}`}>
                        {isCancelable(item?.txt) ? (
                            <Button
                                body={
                                    isProcessingChargesPos &&
                                    clickedButton === item?.id ? (
                                        <Spinner button={true} />
                                    ) : (
                                        t(
                                            !item?.isCancelled
                                                ? t("cancel fee")
                                                : t("add fee"),
                                        )
                                    )
                                }
                                size={"small"}
                                color={!item?.isCancelled ? "red" : "green"}
                                fullWidth={true}
                                data={item?.id}
                                onClickFuction={(event) =>
                                    item?.isCancelled
                                        ? handleUpdateCharge(event, false)
                                        : handleUpdateCharge(event, true)
                                }
                                // disableHTML={
                                //     isProcessingChargesPos &&
                                //     clickedButton === item?.id
                                // }
                                // disabled={
                                //     isProcessingChargesPos &&
                                //     clickedButton === item?.id
                                // }
                            />
                        ) : (
                            <></>
                        )}
                    </span>
                ) : (
                    <></>
                )}
            </div>
        );
    };

    // ------------------------------------------------------------------------------- Charge row

    return (
        <div className={`${styles.main_output_container} v-flex-container`}>
            {label ? (
                <div className={`${styles.output_label}`}>{label}</div>
            ) : (
                <></>
            )}
            <div className={`${styles.output_container}   flex-container`}>
                <div
                    style={{
                        alignItems:
                            align === "center"
                                ? "center"
                                : align === "right"
                                  ? "flex-end"
                                  : "flex-start",
                    }}
                    className={`${styles.output_data}  v-flex-container`}
                >
                    <div className={`flex-container`}>
                        {Icon ? (
                            <div
                                className={`${styles.icon_container} flex-container`}
                            >
                                <Icon
                                    className={` ${styles.icon} icon-component`}
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                        {Array.isArray(data) && data.length ? (
                            <div
                                className={`${styles.expand_button_container} ${
                                    Icon ? styles.output_data_icon_padding : ""
                                } flex-container`}
                            >
                                <span
                                    className={`${styles.expand_button_label}`}
                                >
                                    {placeHolder}
                                </span>
                                <ButtonExpand
                                    CurrentState={showDetails}
                                    onClickFunction={() =>
                                        setShowDetails((prev) => !prev)
                                    }
                                    size={"small"}
                                    dark={true}
                                />
                            </div>
                        ) : (
                            <p className={`${styles.expand_button_label}`}>
                                {notAvialableMessage}
                            </p>
                        )}
                    </div>
                    {Array.isArray(data) && data.length ? (
                        <>
                            {typeof data[0] === "string" ? (
                                <div
                                    className={`${styles.main_output_details_container}  v-flex-container`}
                                >
                                    <div
                                        className={`${
                                            styles.output_details_container
                                        }  ${
                                            showDetails
                                                ? styles.details_visible
                                                : styles.details_hidden
                                        } v-flex-container`}
                                    >
                                        {data.map((item) => (
                                            <div
                                                key={item}
                                                className={`${styles.output_details} ${styles.datails_array_item} flex-container`}
                                            >
                                                {item}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className={`${styles.main_output_details_container} v-flex-container`}
                                >
                                    <div
                                        className={`${
                                            styles.output_details_container
                                        }  ${
                                            showDetails
                                                ? styles.details_visible
                                                : styles.details_hidden
                                        } v-flex-container`}
                                    >
                                        <div
                                            className={`${
                                                styles.output_details
                                            } ${
                                                styles.output_details_header_container
                                            } ${
                                                lastChargesAvailable
                                                    ? styles.charge_padding
                                                    : ""
                                            } flex-container`}
                                        >
                                            <span
                                                className={`${
                                                    styles.output_details_label
                                                } ${
                                                    styles.output_details_type
                                                } ${
                                                    location.pathname.includes(
                                                        "/pos",
                                                    )
                                                        ? styles.extend_pos
                                                        : ""
                                                } `}
                                            >
                                                {t("type")}
                                            </span>
                                            <span
                                                className={`${styles.output_details_label}  ${styles.output_details_date} ${styles.output_details_header} ${styles.condition_hide_2nd}`}
                                            >
                                                {t("date")}
                                            </span>
                                            <span
                                                className={`${styles.output_details_label}   ${styles.output_details_currency} ${styles.condition_hide}`}
                                            >
                                                {t("tax")}
                                            </span>
                                            <span
                                                className={`${styles.output_details_label} ${styles.output_details_currency}`}
                                            >
                                                {t("amount")}
                                            </span>
                                            {location.pathname.includes(
                                                "/pos",
                                            ) && lastChargesAvailable ? (
                                                <span
                                                    className={`${styles.output_details_label} ${styles.output_charge_button}`}
                                                ></span>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        {/* ------------------------------------------------------------------------- Charge row */}
                                        {data.map((item) =>
                                            location.pathname.includes(
                                                "/pos",
                                            ) ? (
                                                <ChargeRow
                                                    key={item?.id}
                                                    item={item}
                                                />
                                            ) : !location.pathname.includes(
                                                  "/pos",
                                              ) && !item?.isCancelled ? (
                                                <ChargeRow
                                                    key={item?.id}
                                                    item={item}
                                                />
                                            ) : (
                                                <></>
                                            ),
                                        )}
                                        {/* ------------------------------------------------------------------------- Charge row */}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OutputDataDetails;
